import React, { useEffect, useState } from "react";
import { FaUserCircle } from "react-icons/fa";
import { useAccessCard } from "../../../ContextProvider/Accesscardprovider";
import { getCurrentUserDetail, getUserDocId, isLoggedIn } from "../../../Localstorage";
import { useLocation, useNavigate } from "react-router-dom";
import { fetchParticularResult, fetchResultData, upsertResultData } from "../../../Firebase/Course-fb";
import Quizscoreskeleton from "./Quizscoreskeleton";

const ScoreCard = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const { quizCode } = useAccessCard();

    const [isLoading, setIsLoading] = useState(true);
    const [topStudents, setTopStudents] = useState([]);
    const [quizData, setQuizData] = useState({
        time: 0,
        answer: [],
        marks: 0,
        timeLeft: 0,
        head: "",
        question: [],
    });

    const getTopStudents = async () => {
        try {
            const quiz_code = sessionStorage.getItem("quizCode");
            const submissions = await fetchResultData(quiz_code);
            console.log(submissions)

            if (submissions && submissions.length > 0) {
                const top5 = submissions
                    .sort((a, b) => b.correct_answered - a.correct_answered)
                    .slice(0, 5);

                console.log("gts = ", top5)
                setTopStudents(top5);
            }
        } catch (error) {
            console.error("Error fetching top students:", error);
        }
    };


    useEffect(() => {
        window.history.pushState(null, "", window.location.href);
        const handlePopState = () => {
            navigate("/", { replace: true });
        };
        window.addEventListener("popstate", handlePopState);
        return () => {
            window.removeEventListener("popstate", handlePopState);
        };
    }, [navigate]);

    useEffect(() => {
        const loadQuizData = async () => {
            let time = Number(location.state?.quizTime ?? 0);
            let answer = location.state?.quizAnswer || [];
            let marks = location.state?.quizMarks;
            let timeLeft = Number(location.state?.quizTimeLeft ?? 0);
            let head = location.state?.quizHead || "";
            let question = location.state?.quizQuestions || [];
            let name = getCurrentUserDetail()[0].name;
            let docId = getUserDocId();

            if (!location.state) {
                const localData = localStorage.getItem("Quiz");
                if (localData) {
                    try {
                        const parsedData = JSON.parse(localData)?.value;
                        time = Number(parsedData?.quizTime ?? 0);
                        answer = parsedData?.quizAnswer || [];
                        marks = parsedData?.quizMarks;
                        timeLeft = Number(parsedData?.quizTimeLeft ?? 0);
                        head = parsedData?.quizHead || "";
                        question = parsedData?.quizQuestions || [];
                    } catch (error) {
                        console.error("Error parsing localStorage quiz data:", error.message);
                    }
                }
            }
            answer = JSON.parse(answer)
            if (typeof question === "string") {
                question = JSON.parse(question);
            } else {
                question = question;
            }
            if (isLoggedIn()) {
                // const studentResult = {
                //     student_name: name,
                //     student_id: docId,
                //     quiz_code: sessionStorage.getItem("quizCode"),
                //     quiz_name: head,
                //     correct_answered: marks,
                //     wrong_answered: (answer.length - answer.filter(item => item === null).length) - marks,
                //     un_answered: answer.filter(item => item === null).length,
                //     attempt_count: 18,
                //     time_taken: (time * 60) - timeLeft, // in seconds
                //     actual_time: time * 60, // in seconds
                //     time_stamp: Date.now(), // Unix timestamp (ms)
                //     question_list: question,
                //     answer_list:answer
                // };
                // console.log(studentResult)
                // await upsertResultData(docId, sessionStorage.getItem("quizCode"), studentResult);
                setQuizData({
                    time,
                    answer,
                    marks,
                    timeLeft,
                    head,
                    question,
                });
            }
            getTopStudents()
            setIsLoading(false);
        };

        loadQuizData();
    }, [location.state, quizCode]);

    const showAnswer = () => {
        navigate('/quiz-answer', {
            state: {
                answer: quizData.answer,
                head: quizData.head,
                question: quizData.question,
            },
        });
    };

    const correct = quizData.marks;
    const total = quizData.answer.length;
    const unanswered = quizData.answer.filter(item => item === null).length;
    const percentage = ((Number(correct) / Number(total)) * 100).toFixed(2);
    const timeTaken = new Date(((quizData.time * 60) - quizData.timeLeft) * 1000).toISOString().slice(11, 19);
    const totalTime = new Date(quizData.time * 60 * 1000).toISOString().slice(11, 19);


    return isLoading ? (
        <Quizscoreskeleton />
    ) : (
        <>
            <div className="topper-card-head score">
                <h3 className="Score-title">Score Board</h3>
                <div className="answerbtn">
                    <button className="ans-btn" onClick={showAnswer}>
                        Solution
                    </button>
                </div>
            </div>

            <div className="score-container">
                <div className="card">
                    <div className="header score">
                        <div>
                            {isLoggedIn() && getCurrentUserDetail()?.[0] && (
                                <>
                                    <h2 className="name">{getCurrentUserDetail()[0].name}</h2>
                                    <p className="contact">{getCurrentUserDetail()[0].mobile_number}</p>
                                </>
                            )}
                        </div>
                        <div className="avatar">
                            <FaUserCircle size={40} color="#2d3748" />
                        </div>
                    </div>

                    <div className="section">
                        <h3 className="topic">Topic: {quizData.head}</h3>
                        <div className="score">
                            <span className="check">✔</span>
                            <p className="score-text">Scored</p>
                        </div>
                        <p className="score-details">
                            {correct} / {total} - Point: 0 - {percentage}%
                        </p>
                    </div>

                    <div className="section">
                        <div className="time">
                            <span className="clock">⏰</span>
                            <p className="time-text">Time Taken</p>
                        </div>
                        <p className="time-details">
                            {timeTaken} / {totalTime}
                        </p>
                    </div>

                    <div className="section border-top">
                        <h3 className="details-header">
                            <span className="note">📝</span>
                            <span className="details-title">Environmental issues</span>
                        </h3>
                        <div className="details">
                            <p>{correct} Correct</p>
                            <p>{total - unanswered - correct} Wrong</p>
                            <p>{unanswered} Unanswered</p>
                            <p>{total} Total</p>
                        </div>
                    </div>
                </div>
            </div>

            <div className="toppers-card">
                <div className="topper-card-head">
                    <h3 className="toppers-title">Toppers List</h3>
                </div>
                {topStudents?.length > 0 &&
                    topStudents.map((item, index) => (
                        <div className="topper-entry" key={item.id || index}>
                            <FaUserCircle size={30} className="topper-icon" />
                            <div>
                                <p className="topper-name">{item.student_name}</p>
                                <p className="topper-stats">
                                    Correct: {item.correct_answered} / {item.question_list.length}
                                </p>
                                <p className="topper-time">
                                    Time:{" "}
                                    {new Date(item.time_taken * 1000).toISOString().slice(11, 19)} /{" "}
                                    {new Date(item.actual_time * 1000).toISOString().slice(11, 19)}
                                </p>
                            </div>
                        </div>
                    ))}
            </div>
        </>
    );
};

export default ScoreCard;
